module.exports = __webpack_public_path__ + "src/assets/textures/env/rake/rake_512_bake.png";